<template>
  <f7-popup class="notification-popup">
    <f7-view>
      <f7-page>
        <div class="page-content-inner justify-content-center">
          <f7-block class="mt-auto display-flex flex-column">
            <img
              :src="`static/${icon}.svg`"
              alt="icon"
              class="notification-popup-icon"
            />
            <span class="notification-popup-title">{{ title }}</span>
            <span class="notification-popup-subtitle">{{ subtitle }}</span>
            <span class="notification-popup-text">{{ text }}</span>

            <f7-button
              fill
              large
              class="custome-large"
              @click="mainActionHandler"
            >
              {{ mainHandlerText }}
              <f7-preloader v-if="loading" color="white"></f7-preloader>
              <f7-icon
                v-else
                f7="arrow_right"
                color="white"
                size="24"
              ></f7-icon>
            </f7-button>
          </f7-block>

          <f7-block class="mt-auto">
            <f7-link @click="secondaryActionHandler">
              {{ secondaryHandlerActionText }}
            </f7-link>
          </f7-block>
        </div>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import notify from '@/js/helpers/notify.js';

export default {
  name: 'NotificationPopup',

  props: {
    icon: {
      type: String,
      default: '',
      required: true
    },

    title: {
      type: String,
      default: '',
      required: true
    },

    subtitle: {
      type: String,
      default: ''
    },

    text: {
      type: String,
      default: ''
    },

    mainHandlerText: {
      type: String,
      default: '',
      required: true
    },

    mainHandlerActionType: {
      type: String,
      default: 'LEAVE'
    },

    secondaryHandlerActionText: {
      type: String,
      default: ''
    },

    // eslint-disable-next-line vue/require-default-prop
    secondaryHandlerActionType: {
      type: String
    }
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    ...mapState({
      lesson: (state) => state.lesson.lesson
    })
  },

  methods: {
    async mainActionHandler() {
      this.loading = true;

      switch (this.mainHandlerActionType) {
        case 'LEAVE': {
          try {
            await this.finishLesson({ id: this.lesson.id });

            this.loading = false;
            this.$f7.popup.close();

            this.$f7.views.main.router.navigate('/feedback', {
              clearPreviousHistory: true,
              props: {
                lessonId: this.lesson.id,
                teacherName: this.lesson.teacher.name
              }
            });
          } catch (error) {
            this.loading = false;
            console.error(error);

            if (error.customeError) {
              notify({ text: error.customeError });
            }
          }

          break;
        }

        case 'COMPLETE': {
          this.$f7.popup.close();
          this.$f7.views.main.router.navigate('/feedback', {
            clearPreviousHistory: true,
            props: {
              lessonId: this.lesson.id,
              teacherName: this.lesson.teacher.name
            }
          });

          break;
        }

        case 'CONTINUE': {
          this.$f7.popup.close();
          this.$f7.views.main.router.navigate('/', {
            clearPreviousHistory: true
          });

          break;
        }
      }
    },

    secondaryActionHandler() {
      switch (this.secondaryHandlerActionType) {
        case 'RETURN': {
          this.$f7.popup.close();
          break;
        }
      }
    },

    ...mapActions({
      finishLesson: 'lesson/finishLesson'
    })
  }
};
</script>

<style lang="less">
.notification-popup {
  --f7-block-padding-horizontal: 30px;

  &-icon {
    margin-bottom: 50px;
    width: 60px;
    height: 60px;
  }

  &-title,
  &-subtitle {
    font-weight: 500;
    font-size: 25px;
    color: #000000;
    letter-spacing: -0.68px;
    line-height: 1.3;
  }

  &-subtitle {
    font-size: 17px;
    margin-bottom: 25px;
  }

  &-text {
    margin-bottom: 50px;
    font-size: 17px;
    line-height: 20px;
    color: #86909b;
    letter-spacing: -0.27px;
  }
}
</style>
